import { createApp } from 'vue';
import FormInput from './form-input.vue'

const app = createApp({});

app
    .mixin(window.vueGlobalMixin)
    .component('FormInput', FormInput)
    .mount('#js-register-vue-root');

$('.j-check-submit-sign-in-form[data-2step="0"]').on( 'click', function( e ) {
    e.preventDefault();

    grecaptcha.execute( RCids['signinRC'] );
});

window.onSubmitSignIn = function onSubmitSignIn() {
    $('#js-signin-form').submit();
}

$('.j-check-submit-register-form').on( 'click', function( e ) {
    e.preventDefault();

    grecaptcha.execute( RCids['registerRC'] );
});

window.onSubmitRegister = function onSubmitRegister() {
    $('#js-register-form').submit();
}


// (()=>{

//     window.addEventListener('load', ()=> {


//         const input = document.querySelectorAll('.j-register__input');

//         let valid = [];


//         const formClearInput = (elem, i) => {

//             elem.addEventListener('click', ()=> {

//                 valid[i] = false;
//             })
//         };

//         const inputListener = (elem, i) => {
//             valid[i] = elem.value.trim().length > 0
//         };

//         const changeListener = (elem, i) => {
//             valid[i] = elem.checked
//         };

//         const formInputChange = (elem, i) => {

//             elem.parentNode.lastChild.classList.contains('register__clear-input')
//             && formClearInput(elem.parentNode.lastChild, i);

//             elem.addEventListener(
//                 (elem.type === 'checkbox'
//                     ? 'change'
//                     : 'input'),
//                 () => {

//                     (elem.type === 'checkbox'
//                         ? changeListener(elem, i)
//                         : inputListener(elem, i));

//                 }
//             );
//         };

//         Array.from(input).forEach((elem, i) => {
//             valid[i] = false;

//             formInputChange(elem, i);

//         });

//     });

// })();
